// Años del combo "Año" de visitas: del actual hacia atrás hasta MIN_VISIT_YEAR. Lo comparten el
// filtro de Visitas y el filtro "Visitas presentadas" de Establecimientos (SMP-452).
export const MIN_VISIT_YEAR = 1970;

export interface VisitYearOption {
    id: number;
    nombre: string;
    value: number;
}

export const buildVisitYearOptions = (
    currentYear = new Date().getFullYear()
): VisitYearOption[] => {
    const years: VisitYearOption[] = [];
    for (let year = currentYear; year >= MIN_VISIT_YEAR; year--) {
        years.push({ id: year, nombre: String(year), value: year });
    }
    return years;
};
